<template>
  <section class="AiReviewsBlock">
    <div class="Layout">
      <div class="Layout-section">
        <grid-item class="AiReviews-header" sm="4" md="4" offset-md="1">
          <ai-skeleton
            desktop-width="230px"
            desktop-height="32px"
            mobile-width="230px"
            mobile-height="32px"
            :bottom-margin="28" />
          <ai-skeleton
            desktop-width="230px"
            desktop-height="16px"
            mobile-width="230px"
            mobile-height="16px"
            :bottom-margin="28" />
          <ai-skeleton
            desktop-width="230px"
            desktop-height="16px"
            mobile-width="230px"
            mobile-height="16px"
            :bottom-margin="28" />
        </grid-item>
        <grid-item sm="4" md="6">
          <div class="AiReviews-rating">
            <ai-skeleton
              desktop-width="190px"
              desktop-height="48px"
              mobile-width="120px"
              mobile-height="48px" />
            <ai-skeleton
              desktop-width="100px"
              desktop-height="16px"
              mobile-width="230px"
              mobile-height="16px" />
          </div>
          <ul id="hotelClientReviews" class="AiReviews-reviewContainer">
            <ai-skeleton
              desktop-width="150px"
              desktop-height="16px"
              mobile-width="150px"
              mobile-height="16px"
              :bottom-margin="6" />
            <ai-skeleton
              desktop-width="90px"
              desktop-height="16px"
              mobile-width="90px"
              mobile-height="16px"
              :bottom-margin="28" />
            <ai-skeleton
              desktop-width="150px"
              desktop-height="16px"
              mobile-width="150px"
              mobile-height="16px"
              :bottom-margin="28" />
            <ai-skeleton
              desktop-width="280px"
              desktop-height="16px"
              mobile-width="220px"
              mobile-height="16px"
              :bottom-margin="6" />
            <ai-skeleton
              desktop-width="350px"
              desktop-height="16px"
              mobile-width="300px"
              mobile-height="16px"
              :bottom-margin="28" />
          </ul>
        </grid-item>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/fonts';
@use '@/assets/styles/utilities/mq';

.AiReviews-header {
  margin-bottom: constants.$margin-04;
}
.AiReviews-title {
  margin-bottom: constants.$margin-02;
}
.AiReviews-description {
  margin-bottom: constants.$margin-02;
}
.AiReviewsBlock {
  padding-bottom: constants.$padding-07;
  padding-top: constants.$padding-07;
}
.AiReview-reviews-container {
  @include fonts.featured;
}
.AiReviews-rating {
  display: flex;
  flex-direction: column;
  margin-bottom: constants.$margin-04;
  padding: constants.$margin-01 constants.$margin-02;
  background: colors.$gold-100;
  @media (mq.$from-medium) {
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
  &--ligth {
    font-size: 0.7em;
  }
}
.AiReview-star-content {
  display: flex;
  &--star {
    display: flex;
    margin-right: constants.$inner-03;
  }
  &--item {
    fill: colors.$gold-900;
    &-half {
      fill: none;
    }
    &-empty {
      fill: none;
    }
  }
}

.AiReviews-button {
  text-transform: uppercase;
}
</style>
